import { Link } from "react-router-dom";
import { H4 } from "../../../../AbstractElements";

export const InvoiceColumns = (propsId) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        width: '50px'
    },
    {
        name: <H4>Actions</H4>,
        selector: row => row.action,
        sortable: true,
        width: '120px'
    },
    {
        name: <H4>Subscriptions</H4>,
        selector: row => row.Subscription,
        sortable: true,
        wrap: true,
        width: '120px'
    },
    {
        name: <H4>Invoice no</H4>,
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.order_id}&customer_id=${propsId}`}>
                {row.Invoice}
            </Link>,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Bin no</H4>,
        selector: row => row.bin_account,
        sortable: true,
        wrap: true,
        width: '110px'
    },
    {
        name: <H4>Invoice Date</H4>,
        selector: row => row.InvoiceDate,
        sortable: true,
        wrap: true,
        width: '110px'
    },
    {
        name: <H4>Due Date</H4>,
        selector: row => row.DueDate,
        sortable: true,
        wrap: true,
        width: '110px'
    },
    {
        name: <H4>Amount Due</H4>,
        selector: row => row.AmountDue,
        sortable: true,

    },
    {
        name: <H4>Total</H4>,
        selector: row => row.Total,
        sortable: true,
        width: '110px',
        wrap: true
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        center: true,
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status.charAt(0).toUpperCase() + row.Status.slice(1)}
            </span>
        ),
    },
    {
        name: <H4>Unit Price</H4>,
        selector: row => row.UnitPrice,
        sortable: true,
        center: true,
        width: '110px',
        wrap: true
    },
    {
        name: <H4>Tax</H4>,
        selector: row => row.Tax,
        sortable: true,
    },
    {
        name: <H4>Created At</H4>,
        selector: row => row.CreatedAt,
        sortable: true,
        width: '120px',
        wrap: true
    },
];

export const paymentHistoryColumns = (propsId) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        width: '50px'
    },
    {
        name: <H4>Receipt No</H4>,
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${row.payment_id}`}>
                {row.payment_id}
            </Link>,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Paid On</H4>,
        selector: row => row.Paidat,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Txn Id</H4>,
        selector: row => row.txnId,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Amount</H4>,
        selector: row => row.Amount,
        sortable: true,
        wrap: true,
        width: '100px'
    },
    {
        name: <H4>Reflected Invoice</H4>,
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.order_id}&customer_id=${propsId}`}>
                {row.RefInvoice}
            </Link>,
        sortable: true,
        center: true,
        width: '165px'
    },
    {
        name: <H4>Reflected Bin</H4>,
        selector: row => row.Bin,
        sortable: true,
        center: true,
        width: '165px'
    },
    {
        name: <H4>Payment Method</H4>,
        selector: row => row.payment_method,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Sales agent</H4>,
        selector: row => row.paid_user,
        sortable: true,
        center: true,
    },
];

export const OrderColumns = (propsId) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        width: '50px'
    },
    {
        name: <H4>Actions</H4>,
        selector: row => row.action,
        sortable: true,
        width: '120px'
    },
    {
        name: <H4>Invoice no</H4>,
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.order_id}&customer_id=${propsId}`}>
                {row.Invoice}
            </Link>,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Invoice Date</H4>,
        selector: row => row.InvoiceDate,
        sortable: true,
        wrap: true,
        width: '130px'
    },
    {
        name: <H4>Total</H4>,
        selector: row => row.Total,
        sortable: true,
        width: '125px',
        wrap: true
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        center: true,
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status.charAt(0).toUpperCase() + row.Status.slice(1)}
            </span>
        ),
    },
    {
        name: <H4>Tax</H4>,
        selector: row => row.Tax,
        sortable: true,
    },
    {
        name: <H4>Created At</H4>,
        selector: row => row.CreatedAt,
        sortable: true,
        width: '125px',
        wrap: true
    },
];